<script lang="ts">
  import { onMount, tick } from "svelte";

  export let items: any[] = [];
  export let itemHeight: number;
  export let itemWidth: number;

  let viewport: HTMLElement;
  let contents: HTMLElement;
  let gridItems: HTMLCollectionOf<HTMLElement>;

  let rowHeights: number[] = [];

  let viewportHeight: number;
  let viewportWidth: number;

  let itemsPerRow;
  let numberOfRows;

  let mounted;

  let top = 0;
  let bottom = 0;

  let start = 0;
  let end = 0;

  $: visibleItems = items
    .slice(start, end)
    .map((value, idx) => ({ value, key: idx + start }));

  $: if (mounted)
    refresh(items, viewportHeight, viewportWidth, itemHeight, itemWidth);

  async function refresh(
    items: any[],
    viewportHeight: number,
    viewportWidth: number,
    itemHeight: number,
    itemWidth: number
  ) {
    await tick();
    const { scrollTop } = viewport;

    let contentHeight = top - scrollTop;
    itemsPerRow = Math.floor(viewportWidth / itemWidth);
    numberOfRows = Math.ceil(items.length / itemsPerRow);

    let i = start;
    while (contentHeight < viewportHeight && i < items.length) {
      // console.log("contentHeight:", contentHeight);
      // console.log("viewportHeight:", viewportHeight);
      // console.log("i:", i);
      // console.log("items.length:", items.length);

      let row = gridItems[i - start];

      if (!row) {
        end = i + itemsPerRow;
        await tick();
      }

      contentHeight += itemHeight;
      i += itemsPerRow;
    }

    end = i;

    const remaining = Math.ceil((items.length - end) / itemsPerRow);
    bottom = remaining * itemHeight;

    rowHeights.length = numberOfRows;
  }

  async function onScroll() {
    const { scrollTop } = viewport;
    const oldStart = start;

    let i = 0;
    let y = 0;

    while (i < items.length) {
      if (y + itemHeight > scrollTop) {
        start = i;
        top = y;
        break;
      }

      y += itemHeight;
      i += itemsPerRow;
    }

    while (i < items.length) {
      y += itemHeight;
      i += itemsPerRow;

      if (y > scrollTop + viewportHeight) break;
    }

    end = i;

    const remaining = Math.ceil((items.length - end) / itemsPerRow);
    bottom = remaining * itemHeight;

    if (start < oldStart) {
      await tick();
      let expectedHeight = 0;
      let actualHeight = 0;

      for (let i = start; i < oldStart; i += itemsPerRow) {
        if (gridItems[i - start]) {
          expectedHeight += itemHeight;
          actualHeight += gridItems[i - start].offsetHeight;
        }
      }

      const d = actualHeight - expectedHeight;
      viewport.scrollTo(0, scrollTop + d);
    }
  }

  onMount(() => {
    mounted = true;
    gridItems = contents.getElementsByTagName(
      "virtualised-grid-item"
    ) as HTMLCollectionOf<HTMLElement>;
  });
</script>

<virtualised-grid
  bind:this={viewport}
  bind:offsetHeight={viewportHeight}
  bind:offsetWidth={viewportWidth}
  on:scroll={onScroll}
>
  <virtualised-grid-contents
    style="padding-top: {top}px; padding-bottom: {bottom}px; grid-template-columns: repeat(auto-fill, minmax({itemWidth}px, 1fr))"
    bind:this={contents}
  >
    {#each visibleItems as item (item.key)}
      <virtualised-grid-item>
        <slot data={item.value}>
          <div>Put Children Here</div>
        </slot>
      </virtualised-grid-item>
    {/each}
  </virtualised-grid-contents>
</virtualised-grid>

<style>
  virtualised-grid {
    display: block;
    height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 1em;
  }

  virtualised-grid-contents {
    max-width: 500px;
    margin: auto;
    display: grid;
    text-align: center;
  }
</style>
